// libs
import { styled } from '@nykaa/ui-components';

export const AlphabetsContainer = styled.div`
  text-transform: uppercase;
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  padding-top: ${({ theme }) => theme.spacing.spacing40};
  padding-left: ${({ theme }) => theme.spacing.spacing120};
`;

export const Alphabet = styled.span<{ isDisabled: boolean }>`
  margin-right: ${({ theme }) => theme.spacing.spacing40};

  &:hover {
    cursor: pointer;
    ${({ theme }) => theme.typography.buttonMedium};
    color: ${({ theme }) => theme.colors.secondary};
  }

  ${({ isDisabled, theme }) =>
    isDisabled &&
    ` color: ${theme.colors.surface40};
      pointer-events: none;
    `};
`;
